export enum ChannelType {
  EMAIL = 'eMail',
  EDI = 'EDI',
  EBILL = 'eBill',
  PRINT = 'Print',
  EPOST = 'ePost'
}

export enum TransactionStatus {
  COMPLETED = 'Completed',
  PAID = 'Paid',
  PENDING = 'Pending',
  FAILED = 'Failed'
}

export enum DocumentType {
  INVOICE = 'Invoice',
  ORDER = 'Order',
  DELIVERY_NOTE = 'Delivery Note'
}

export type Period = '1h' | '4h' | 'Day' | 'Week' | 'Month' | 'Year';

export interface Transaction {
  id: string;
  customerName: string;
  customerInitials: string;
  transactionNumber: string;
  invoiceNumber: string;
  timestamp: string;
  channel: ChannelType;
  status: TransactionStatus;
  amount?: number;
  type: DocumentType;
}

export interface StatData {
  paid: number;
  overdue: number;
  pending: number;
  currency: string;
  count: number;
}